/* eslint-disable no-unused-vars */

import {
  put, call, takeLatest,
} from 'redux-saga/effects';

import {
  MODALS, API_URLS, FETCH_OPTIONS, SUCCESS_MODALS, MARKET_MARGINS_ERROR,
} from '../constants';
import { requestGet, requestPost } from '../utils/request';
import { aGetMarketMarginsRequest, aGetTennisMarketMargins, aUpdateMarketMarginsRequest, aUpdateTennisMarketMarginsRequest } from '../reducers';
import { aSetIsFetching, aSetOpenModal } from '../reducers/common';
import { aGetMarketMarginsSuccess, aGetTennisMarketMarginsSuccess, aUpdateMarketMargins, aUpdateTennisMarketMargins } from '../reducers/marketMargins';

/**
 * @memberof sagas/marketMargins
 * @async
 * @param {object} action
 */
function* getMarketMarginsSaga(action) {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_MARKET_MARGINS,
      value: true,
    }));

    response = yield call(requestGet, API_URLS.GET_MARKET_MARGINS, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aGetMarketMarginsSuccess({
        marketMargins: response.data,
      }));
    }
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_MARKET_MARGINS,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.GET_MARKET_MARGINS,
      value: false,
    }));
  }
}

/**
 * @memberof sagas/marketMargins
 * @async
 */
function* getTennisMarketMarginsSaga() {
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_TENNIS_MARKET_MARGINS,
      value: true,
    }));

    const response = yield call(requestGet, API_URLS.GET_TENNIS_MARKET_MARGINS, true);

    if (response.status === -1) {
      throw Error(response.error.message);
    } else {
      yield put(aGetTennisMarketMarginsSuccess({
        marketMargins: response.data,
      }));
    }
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.GET_TENNIS_MARKET_MARGINS,
      value: false,
    }));
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.GET_TENNIS_MARKET_MARGINS,
      value: false,
    }));
  }
}

/**
 * @param {object} action
 */
function* updateMarketMarginsSaga(action) {
  let response;
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.UPDATE_MARKET_MARGINS,
      value: true,
    }));

    const data = {
      marketMargins: action.payload?.map((settings) => ({
        marketId: settings?.marketId,
        levels: settings?.levels,
        marginOverride: settings?.marginOverride,
      })),
    };

    response = yield call(requestPost, API_URLS.UPDATE_MARKET_MARGINS, data, true);

    if (response.status === -1) {
      const error = new Error(response.error.message);
      if (MARKET_MARGINS_ERROR[response.error.code]) {
        error.modal = MODALS.ERROR;
        error.message = MARKET_MARGINS_ERROR[response.error.code];
      }
      throw error;
    } else {
      yield put(aUpdateMarketMargins({
        marketMargins: {
          marketMargins: action.payload,
        },
      }));

      yield put(aSetOpenModal({
        modal: MODALS.SUCCESS,
        modalData: {
          message: SUCCESS_MODALS.UPDATE_MARKET_MARGINS_SETTINGS,
          additionalMessage: 'successfully',
          modal: SUCCESS_MODALS.UPDATE_MARKET_MARGINS_SETTINGS,
        },
      }));

      yield put(aSetIsFetching({
        key: FETCH_OPTIONS.UPDATE_MARKET_MARGINS,
        value: false,
      }));
    }
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.UPDATE_MARKET_MARGINS,
      value: false,
    }));
  }
}

/**
 * @param {object} action
 */
function* updateTennisMarketMarginsSaga(action) {
  try {
    yield put(aSetIsFetching({
      key: FETCH_OPTIONS.UPDATE_TENNIS_MARKET_MARGINS,
      value: true,
    }));

    const data = {
      marketMargins: action.payload?.map((settings) => ({
        marketId: settings?.marketId,
        levels: settings?.levels,
      })),
    };

    const response = yield call(requestPost, API_URLS.UPDATE_TENNIS_MARKET_MARGINS, data, true);

    if (response.status === -1) {
      throw new Error(response.error.message);
    } else {
      yield put(aUpdateTennisMarketMargins({
        marketMargins: {
          marketMargins: action.payload,
        },
      }));

      yield put(aSetOpenModal({
        modal: MODALS.SUCCESS,
        modalData: {
          message: SUCCESS_MODALS.UPDATE_TENNIS_MARKET_MARGINS_SETTINGS,
          additionalMessage: 'successfully',
          modal: SUCCESS_MODALS.UPDATE_TENNIS_MARKET_MARGINS_SETTINGS,
        },
      }));

      yield put(aSetIsFetching({
        key: FETCH_OPTIONS.UPDATE_TENNIS_MARKET_MARGINS,
        value: false,
      }));
    }
  } catch (error) {
    yield put(aSetOpenModal({
      modal: error.modal || MODALS.GENERAL_ERROR,
      errorMessage: error.modal ? error.message : MODALS.GENERAL_ERROR,
      key: FETCH_OPTIONS.UPDATE_TENNIS_MARKET_MARGINS,
      value: false,
    }));
  }
}
/**
 * @memberof sagas/marketMargins
 * @async
 * @returns {void}
 */
export default function* marketMarginsSaga() {
  yield takeLatest(aGetMarketMarginsRequest, getMarketMarginsSaga);
  yield takeLatest(aUpdateMarketMarginsRequest, updateMarketMarginsSaga);
  yield takeLatest(aGetTennisMarketMargins, getTennisMarketMarginsSaga);
  yield takeLatest(aUpdateTennisMarketMarginsRequest, updateTennisMarketMarginsSaga);
}

